<template>
  <div v-if="application">
    <section class="application-create__form">
      <div class="container-xxxl">
        <div class="row">
          <div class="col-xxl-6 offset-xxl-3">
            <h3 class="application__form__title">{{ $lang.app.GENERAL_INFORMATION }}</h3>
            <div class="application__form__block">
              <div class="row">
                <div class="col-lg-6">
                  <div class="stack__list mb1">
                    <div class="stack__label">{{ $lang.app.APPLICATION_NUMBER }}</div>
                    <div class="stack__value">{{ application.docNumber }}</div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="stack__list mb1">
                    <div class="stack__label">{{ $lang.app.STATUS }}</div>
                    <div class="stack__value"><span class="badge green__lighter">{{ status }}</span></div>
                  </div>
                </div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.PROJECT_NAME }}</div>
                <div class="stack__value break-words">{{ application.name }}</div>
              </div>
              <div v-if="application.prevConclusion" class="stack__list">
                <div class="stack__label">{{ $lang.app.CONCLUSION_NUMBER }}</div>
                <div class="stack__value">{{ application.prevConclusion.number }}</div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.ADDITIONAL_EXPERTISE }}</div>
                <div class="stack__value">{{ additionalExpertises }}</div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.CONSTRUCTION_TYPE }}</div>
                <div class="stack__value">{{ constructionType }}</div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.OBJECT_POSTAL_ADDRESS }}</div>
                <div class="stack__value">{{ application.address?.addressTxt }}</div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.EXPERTIZE_PAYMENT_SOURCE }}</div>
                <div class="stack__value">{{ application.paymentSourceTxt }}</div>
              </div>
              <div class="stack__list mb-4">
                <div class="stack__label">{{ $lang.app.OWNERSHIP_FORM }}</div>
                <div class="stack__value">{{ $lang.app[ownershipTypesGetLabelRefByValue(application.ownership)] }}</div>
              </div>
              <div class="stack__label">{{ $lang.app.MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT }}</div>
              <div class="row">
                <div v-for="(economicIndicator, index) in application.economicIndicators" :key="index"
                     class="col-lg-6">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ economicIndicator.name }}
                      <button v-if="editable" type="button" @click="deleteEconomicIndicator(economicIndicator)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="add__field__value__area">
                      {{ economicIndicator.value }} {{ unitOfMeasurements.find(item => item.id === economicIndicator.unitOfMeasurement)?.label }}
                    </div>
                    <button v-if="editable" type="button" class="add__field__edit"
                            @click="$emitter.emit('open-applicant-application-indicator-edit-modal', economicIndicator)">
                      <svg viewBox="0 0 24 24" width="24" height="24">
                        <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                      </svg>
                      {{ $lang.app.EDIT }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="input__group">
                <button v-if="application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')" type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                        @click="$emitter.emit('open-applicant-application-indicator-create-modal')">
                  <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                  </svg>
                  <span class="button__text">{{ $lang.app.MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT }}</span>
                </button>
              </div>
              <IndicatorCreateModal/>
              <IndicatorEditModal/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="application-create__controls">
      <div class="container-fluid">
        <div class="application-create__controls__wrapper">
          <button type="button" @click="$router.go(-1)" class="button button--cancel">{{ $lang.app.CANCEL }}</button>
          <button v-if="application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')"
                  type="button"
                  class="button button--bordered button__icon--left"
                  @click="handleAction('APPLICANT_EDIT_ACTION')">
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
            </svg>
            {{ $lang.app.EDIT }}
          </button>
          <router-link :to="{name: 'ApplicantApplicationCustomerDetail', params: {applicationId: application.id}}"
                       class="button button__icon--right">{{ $lang.app.NEXT }}
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import applicationApi from "../../../../api/applicant/application";
import {getLabelRefByValue as ownershipTypesGetLabelRefByValue} from "../../../../helpers/constants/ownershipTypes";
import unitOfMeasurementApi from "../../../../api/ref/unitOfMeasurement";
import IndicatorCreateModal from "../../../../components/applicant/application/modals/IndicatorCreateModal.vue";
import IndicatorEditModal from "../../../../components/applicant/application/modals/IndicatorEditModal.vue";

export default {
  name: "ApplicantApplicationMainDetail",
  components: {
    IndicatorCreateModal,
    IndicatorEditModal,
  },
  props: {
    application: Object,
  },
  data() {
    return {
      unitOfMeasurements: [],
    }
  },
  computed: {
    editable() {
      return this.application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')
    },
    additionalExpertises() {
      return this.application.additionalExpertise
          .map((item) => this.$lang.$translate({ ru: item.nameRu, kg: item.nameKg }))
          .join(", ");
    },
    constructionType() {
      if (this.application.constructionType) {
        return this.$lang.$translate({
          ru: this.application.constructionType.nameRu,
          kg: this.application.constructionType.nameKg,
        });
      }
      return "";
    },
    appointment() {
      if (this.application.appointment) {
        return this.$lang.$translate({
          ru: this.application.appointment.nameRu,
          kg: this.application.appointment.nameKg,
        });
      }
      return "";
    },
    status() {
      if (this.application.status) {
        return this.$lang.$translate({
          ru: this.application.status.nameRu,
          kg: this.application.status.nameKg,
        });
      }
      return "";
    },
  },
  created() {
    this.getUnitOfMeasurements();
  },
  methods: {
    ownershipTypesGetLabelRefByValue,
    getUnitOfMeasurements() {
      unitOfMeasurementApi.getUnitOfMeasurements()
          .then(response => {
            this.unitOfMeasurements = response.map(el => {
              return {id: el.id, label: el.shortName}
            })
          }).catch(error => {
        console.log(error);
      })
    },
    handleAction(action) {
      switch (action) {
        case 'APPLICANT_EDIT_ACTION':
          if(this.application.prevConclusion) {
            this.$router.push({
              name: "ApplicantApplicationMainRepeatedEdit",
              params: { applicationId: this.application.id },
            }); break;
          } else {
            this.$router.push({
              name: "ApplicantApplicationMainEdit",
              params: { applicationId: this.application.id },
            }); break;
          }
        case 'APPLICANT_DELETE_ACTION': this.deleteApplication(this.application.id); break;
      }
    },
    deleteEconomicIndicator(economicIndicator) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteEconomicIndicator(this.application.id, economicIndicator.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    deleteApplication(applicationId) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteApplication(applicationId)
              .then(() => {
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
                this.$router.push({name: 'ApplicantApplicationsList'})
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    }
  },
};
</script>
